<h2>{{this.data?.['name']}}</h2>
<div class="table-responsive">
<table class="mt-4 mat-table">
	<thead>
		<tr class="mat-header-row">
			<th class="mat-header-cell">
				&nbsp;
			</th>

			<th class="mat-header-cell text-end">
				PRE
			</th>

			<th class="mat-header-cell text-end">
				ORI
			</th>

			<th class="mat-header-cell text-end">
				EXT
			</th>

			<th class="mat-header-cell text-end">
				REN
			</th>

			<th class="mat-header-cell text-end">
				MISC
			</th>

			<th class="mat-header-cell text-end">
				NON UNIT
			</th>

			<!-- <th class="mat-header-cell">
				PORI
			</th> -->

			<th class="mat-header-cell text-end">
				SUNDRY
			</th>

			<th class="mat-header-cell text-end">
				REFUNDS
			</th>

			<th class="mat-header-cell text-end">
				Total
			</th>
		</tr>
	</thead>


	<tr class="mat-row">
		<td class="mat-cell">
			(WEEK)
		</td>
		<td class="mat-cell text-end">
			{{this.data?.['WEEK_PRE'] | studioCurrency}}
		</td>
		<td class="mat-cell text-end">
			{{this.data?.['WEEK_ORI'] | studioCurrency}}
		</td>
		<td class="mat-cell text-end">
			{{this.data?.['WEEK_EXT'] | studioCurrency}}
		</td>
		<td class="mat-cell text-end">
			{{this.data?.['WEEK_REN'] | studioCurrency}}
		</td>
		<td class="mat-cell text-end">
			{{this.data?.['WEEK_MISC'] | studioCurrency}}
		</td>
		<td class="mat-cell text-end">
			{{this.data?.['WEEK_NONUNIT'] | studioCurrency}}
		</td>
		<!-- <td class="mat-cell">
			${{this.data?.['WEEK_PORI']}}
		</td> -->
		<td class="mat-cell text-end">
			{{this.data?.['WEEK_SUNDRY'] | studioCurrency}}
		</td>
		<td class="mat-cell text-end">
			{{this.data?.['WEEK_REFUND'] | studioCurrency}}
		</td>
		<td class="mat-cell text-end">
			{{ this.data?.['WEEK_PRE'] + this.data?.['WEEK_ORI'] + this.data?.['WEEK_EXT'] +
			this.data?.['WEEK_MISC'] + this.data?.['WEEK_NONUNIT'] +
			this.data?.['WEEK_SUNDRY'] + this.data?.['WEEK_REN'] - this.data?.['WEEK_REFUND'] | studioCurrency }}
		</td>
	</tr>

	<tr class="mat-row">
		<td class="mat-cell">
			(YTD)
		</td>
		<td class="mat-cell text-end">
			{{this.data?.['PRE'] | studioCurrency}}
		</td>
		<td class="mat-cell text-end">
			{{this.data?.['ORI'] | studioCurrency}}
		</td>
		<td class="mat-cell text-end">
			{{this.data?.['EXT'] | studioCurrency}}
		</td>
		<td class="mat-cell text-end">
			{{this.data?.['REN'] | studioCurrency}}
		</td>
		<td class="mat-cell text-end">
			{{this.data?.['MISC'] | studioCurrency}}
		</td>
		<td class="mat-cell text-end">
			{{this.data?.['NONUNIT'] | studioCurrency}}
		</td>
		<!-- <td class="mat-cell">
			${{this.data?.['PORI']}}
		</td> -->
		<td class="mat-cell text-end">
			{{this.data?.['SUNDRY'] | studioCurrency}}
		</td>
		<td class="mat-cell text-end">
			{{this.data?.['REFUND'] | studioCurrency}}
		</td>
		<td class="mat-cell text-end">
			{{ this.data?.['PRE'] + this.data?.['ORI'] + this.data?.['EXT'] +
				this.data?.['MISC'] + this.data?.['NONUNIT'] +
				this.data?.['SUNDRY'] + this.data?.['REN'] - this.data?.['REFUND'] | studioCurrency }}
		</td>
	</tr>

</table>
</div>
